import { Component, OnInit } from '@angular/core';
import {ListeOrganisation} from '../../../../../model/liste/ListeOrganisation';
import {Organisation} from '../../../../../model/organisation/Organisation';
import {ListeOrganisationOrganisation} from '../../../../../model/liste/ListeOrganisationOrganisation';
import {AuthShareService} from '../../../../../service/partage/AuthShareService';
import {DialogueShareService} from '../../../../../service/partage/utilitaire/DialogueShareService';
import {ActivatedRoute, Router} from '@angular/router';
import {OrganisationService} from '../../../../../service/interne/organisation/OrganisationService';
import {ListeOrganisationService} from '../../../../../service/interne/organisation/ListeOrganisationService';

@Component({
  selector: 'app-escal-liste-organisation-modifier',
  templateUrl: './escal-liste-organisation-modifier.component.html',
  styleUrls: ['./escal-liste-organisation-modifier.component.scss'],
  providers: [ ListeOrganisationService, OrganisationService ]
})
export class EscalListeOrganisationModifierComponent implements OnInit {

  private sub: any;
  listeOrganisation: ListeOrganisation;
  organisations: Array<Organisation>;
  organisationsIds: Array<any> = [];
  organisationsChoix: Array<Organisation>;
  idOrganisationsSelectionnees: Array<any> = [];
  idOrganisationsASauvegarder: Array<any> = [];
  organisationSelect: Organisation;
  assosOrganisationsListe: Array<ListeOrganisationOrganisation>;
  listeId: number;
  cree: boolean;
  champRechercheOrganisation = '';
  selectElement: Array<any> = [];
  redirection: boolean;
  constructor(private authShareService: AuthShareService,
              private organisationService: OrganisationService, private dialogueShareService: DialogueShareService,
              private listeOrganisationService: ListeOrganisationService, private route: ActivatedRoute,
              private router: Router) { }

  ngOnInit() {
    this.cree = false;
    this.redirection = false;
    this.listeId = 0;
    this.organisations = [];
    this.organisationsChoix = [];
    this.assosOrganisationsListe = [];
    this.sub = this.route.params.subscribe(params => {
      this.listeOrganisationService.getListeOrganisationDetails(params.id)
        .then((listeOrganisation) => {
          this.listeOrganisation = listeOrganisation as ListeOrganisation;
          this.listeOrganisationService.getOrganisationsListeAssociees(this.listeOrganisation.id).then((organisationsListe) => {
            this.organisations = organisationsListe['hydra:member'] as Array<Organisation>;
          });
        });
      this.listeOrganisationService.getListeOrganisationAllAssos(params.id).then((assosOrganisationsListe) => {
        this.assosOrganisationsListe = assosOrganisationsListe['hydra:member'] as Array<ListeOrganisationOrganisation>;
      });
    });
  }

  rechercheOrganisation() {
    this.organisationsChoix = [];
    let organisationPresent;
    this.organisationService.getSocieteByNom(this.champRechercheOrganisation)
      .then((data) => {
        const organisationsAll = data['hydra:member'] as Array<Organisation>;
        organisationsAll.forEach(organisation => {
          organisationPresent = this.organisations.find((list) => list.id === organisation.id);
          if (organisationPresent === undefined) {
            this.organisationsChoix.push(organisation);
          }
        });
      });
  }

  setSelected(selectElement, action, nature) {
    const groupe: Array<any> = [];
    let optionSelected;
    for (let i = 0; i < selectElement.options.length; i++) {
      if (selectElement.options[i].selected) {
        optionSelected = selectElement.options[i].value;
        // Le format de value est de [0: '1']
        if (optionSelected.indexOf('\'') !== -1) {
          // extraire le vrai id sauvegarder
          optionSelected = optionSelected.indexOf('\'');
          optionSelected = selectElement.options[i].value.slice(optionSelected);
          optionSelected = this.extraitNombre(optionSelected);
          optionSelected = optionSelected.toString();
        }
        groupe.push(optionSelected);
      }
    }
    this.selectElement = groupe;
    if (action === 'add') {
      switch (nature) {
        case 'liste':
          this.idOrganisationsSelectionnees = groupe;
          break;
      }
    } else if (action === 'delete') {
      switch (nature) {
        case 'liste':
          this.idOrganisationsASauvegarder = groupe;
          break;
      }
    }
  }

  extraitNombre(str) {
    return Number(str.replace(/\D/g, ''));
  }

  changeOrganisation(action) {
    const that = this;
    let nouvelleListeOrganitions;
    let listeOrganisations;
    let organisationPresent;
    if (action === 'add') {
      listeOrganisations = this.idOrganisationsSelectionnees;
    } else {
      listeOrganisations = this.idOrganisationsASauvegarder;
    }
    listeOrganisations.forEach((idOrganisationSelectionnees) => {
      that.organisationService.getOrganisationDetails(idOrganisationSelectionnees).then(retour => {
        that.organisationSelect = retour as Organisation;
        if (action === 'add') {
          // retirer la(es) société(s) sélectionnée(s) dans la liste de base
          nouvelleListeOrganitions = this.organisationsChoix.filter((organisation) => organisation.id !== that.organisationSelect.id);
          this.organisationsChoix = nouvelleListeOrganitions;
          // évite les doublons
          organisationPresent = this.organisations.find((org) => org.id === that.organisationSelect.id);
          if (organisationPresent === undefined) {
            this.organisations.push(that.organisationSelect);
          }
        } else if (action === 'delete') {
          // retirer la(es) société(s) sélectionnée(s) dans la liste à sauvegarder
          nouvelleListeOrganitions = this.organisations.filter((org) => org.id !== that.organisationSelect.id);
          this.organisations = nouvelleListeOrganitions;
          // évite les doublons
          organisationPresent = this.organisationsChoix.find((org) => org.id === that.organisationSelect.id);
          if (organisationPresent === undefined) {
            this.organisationsChoix.push(that.organisationSelect);
          }
        }
      });
    });
  }

  detailOrganisation(selectElement) {
    const url = this.router.createUrlTree(['/escal/societe/' + selectElement[0]]);
    window.open(url.toString(), '_blank');
  }

  modifierListe() {
    // si informations obligatoires non renseignées
    if (this.listeOrganisation.nom != '') {
      // empeche la creation de multiple liste
      this.cree = true;
      // modifier liste
      this.listeOrganisationService.modifierListeOrganisation(this.listeOrganisation).then(async listeOrganisation => {
        this.listeId = listeOrganisation.id;
        if (this.organisations.length > 0) {
          for (const assoOrganisationListe of this.assosOrganisationsListe) {
            // Sinon mettre à jour les assos via la selection dans le formulaire escalnet
            await this.listeOrganisationService.supprimerAssoListeOrganisation(assoOrganisationListe.id).then(() => {
            });
          }
          for (const organisation of this.organisations) {
            await this.listeOrganisationService.addOrganisationListe(this.listeId, organisation.id);
          }
        } else {
          for (const assoOrganisationListe of this.assosOrganisationsListe) {
            await this.listeOrganisationService.supprimerAssoListeOrganisation(assoOrganisationListe.id).then(() => {
            });
          }
        }
        // enregistrer liste parution dans la base d'intranet
        await this.listeOrganisationService.importerListeOrganisationIntranet(listeOrganisation.id, this.listeOrganisation.ancienId)
          .then(async (ancienIdListe) => {
            this.dialogueShareService.addDialogue('La liste a bien été modifiée');
            this.redirection = true;
          });
      });
    } else {
      this.dialogueShareService.addDialogue('Le nom est obligatoire');
    }
  }

}
